export default __webpack_public_path__ + "static/media/img-2.f5b9244c.png";